// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#1693ff"};